import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#FFD700]/20 py-10 px-4" data-id="element-161">
      <div className="max-w-3xl mx-auto text-center" data-id="element-162">
        <div className="text-[#FFD700] text-2xl font-black tracking-widest mb-4" data-id="element-163">
          💃 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-164">
          El sistema de clases N°1 para profesores de tango en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-165">
          Porque enseñar tango no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-166">
          <span data-id="element-167">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-168">•</span>
          <span data-id="element-169">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-170">•</span>
          <span data-id="element-171">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#FFD700]/20 mb-6" data-id="element-172" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-173">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-174">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}